export default __webpack_public_path__ + "static/schedule-6b131958679bbfcc2d8bac21196582c4.jpg";